import { connect } from 'react-redux';
import ListPoliticaCobranca from './listPoliticaCobranca';

export default connect()(ListPoliticaCobranca);
